import Radio from '@/components/Radio/Radio';
import Section from '@latitude/section-rebrand';
import { Body2} from '@/components/Text/TextV1';
import {
  BREAKPOINT,
  COLOR,
  MARGIN,
  PADDING,
  REBRAND_COLOR
} from '@latitude/core/utils/constants';
import styled from 'styled-components';

export const Wrapper = styled.div`
 background: ${REBRAND_COLOR.MID_BLUE_10};
`;

export const MainWrapper = styled(Section)`
  padding-top: ${PADDING.P32};
  padding-bottom: ${PADDING.P32};
  background: ${REBRAND_COLOR.MID_BLUE_10};
  @media (min-width: ${BREAKPOINT.LG}) {
    padding-top: ${PADDING.P16};
    padding-bottom: ${PADDING.P16};
  }
`;

export const StyledGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: 1fr;
  gap: 1rem;
  margin-top: ${MARGIN.M24};
  @media (min-width: ${BREAKPOINT.MD}) {
    grid-template-columns: repeat(
      ${({ length }) => (length && length > 3 ? 3 : length)},
      1fr
    );
    grid-template-rows: 1fr;
  }
`;

export const StyledGridSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const RadioCard = styled.div`
  background: ${COLOR.WHITE};
  padding: ${PADDING.P16};
  border-radius: 8px;
  display: flex;
  flex-direction: row;
  align-items: start;
  gap: 16px;
  border: 1px solid
    ${({ selected }) =>
      selected ? `${REBRAND_COLOR.MID_BLUE}` : `${REBRAND_COLOR.BLACK_40}`};
  cursor: pointer;
`;

export const StyledRadio = styled(Radio)`
  min-width: 24px;
  min-height: 24px;
  margin: 0;
  padding: 0;
  border: 1px solid ${REBRAND_COLOR.BLACK_70};
  &:checked {
    border: 3px solid ${REBRAND_COLOR.MID_BLUE};
    &::after {
      background: none;
    }
  }
`;

export const StyledButtonWrapper = styled.div`
  margin-top: ${MARGIN.M24};
`;

export const StyledTC = styled(Body2)`
  margin-top: ${MARGIN.M24};
`;
